import React, { useState } from "react";
import { Button, Card, Col, Placeholder, Row } from "react-bootstrap";
import { FaRegClock } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
import {
  // formatDateWithoutTimezoneMMDDYYYY,
  formatToUSDate,
} from "../../utils/dateFormat";
import { RxShare1 } from "react-icons/rx";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import ShareModal from "../common/ShareModal";
import { useSelector } from "react-redux";
import { formatEventDate } from "../../../src/utils/formatEventDate";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";
const EventCard = ({ isLoading, item, isMember }) => {
  const navigate = useNavigate();
  const now = new Date();
  const { user } = useSelector((state) => state.USER_DATA);

  const isMembershipValidForEvent = (expiryDate, eventDate) => {
    if (!expiryDate || !eventDate) return false;

    return new Date(expiryDate).getTime() >= new Date(eventDate).getTime();
  };

  const eventEndOrStart = item?.end_date || item?.start_date;
  const isPastEvent = eventEndOrStart ? new Date(eventEndOrStart) < now : false;
  const [showShare, setShowShare] = useState(false);

  const shareLink =
    item?._id && typeof window !== "undefined"
      ? `${window.location.origin}/events/${item._id}`
      : "";

  console.log(item);

  return (
    <>
      {isLoading ? (
        <>
          <Col lg={4} md={6} sm={12}>
            <Card className="h-100 shadow-sm skeleton-card">
              <Skeleton
                height={180}
                width={"100%"}
                style={{ display: "block", margin: 0, padding: 0 }}
              />

              <Card.Body>
                <Placeholder as={Card.Title} animation="glow">
                  <Placeholder xs={6} />
                </Placeholder>

                <Placeholder as={Card.Text} animation="glow">
                  <Placeholder xs={7} /> <Placeholder xs={4} />{" "}
                  <Placeholder xs={4} /> <Placeholder xs={6} />{" "}
                  <Placeholder xs={8} />
                </Placeholder>

                <Row className="mt-3 d-flex align-items-center justify-content-evenly g-2">
                  <Col>
                    <Placeholder.Button
                      variant="warning"
                      className="w-100 py-2"
                    />
                  </Col>

                  {/* <Col xs={5}>
                    <Placeholder.Button
                      variant="warning"
                      className="w-100 py-2"
                    />
                  </Col> */}

                  <Col xs={2}>
                    <Placeholder.Button
                      variant="outline"
                      className="w-100 py-2"
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </>
      ) : (
        <Col key={item._id} lg={4} md={6} sm={12}>
          <Card
            className="rsvp-card h-100 cursor-pointer"
            onClick={() => {
              navigate(`/events/${item._id}`);
            }}
          >
            <div className="event-image-section">
              <Card.Img
                className="rsvp-card-img"
                variant="top"
                src={`${IMAGE_BASEURL}${item?.image_path}`}
                alt={item?.title || "Event Image"}
              />
            </div>
            <Card.Body className="d-flex flex-column h-100 p-4">
              <div className="flex-grow-1">
                <Card.Title className="eventcard-title fw-bold mb-2 text-main">
                  {item?.title}
                </Card.Title>
                {item?.price &&
                  (isMember &&
                  isMembershipValidForEvent(
                    user.membership_expiry_date,
                    item?.start_date
                  ) ? (
                    <Card.Text className="text-warning mb-2">
                      {" "}
                      {user.member_price
                        ? ` ${new Date(
                            item?.start_date
                          ).getFullYear()} Members: ${user.member_price}`
                        : `Free to ${new Date(
                            item?.start_date
                          ).getFullYear()} Members`}
                    </Card.Text>
                  ) : (
                    <Card.Text className="ticket-price mb-2 fw-medium f-16">
                      Non-Members ${Number(item?.price).toFixed(2)}
                    </Card.Text>
                  ))}

                {item?.description && (
                  <Card.Text className="mb-2 event-description">
                    {item?.description}
                  </Card.Text>
                )}

                {/* <Card.Text className="d-flex align-items-center mb-2 mt-3 event-timing-info">
                  <FaRegClock size={16} />

                  <span className="ps-2 ms-1">
                    {(() => {
                      const parseDate = (value) => {
                        if (!value || typeof value !== "string") return null;
                        const d = new Date(value);
                        return Number.isNaN(d.getTime()) ? null : d;
                      };

                      const startDate = parseDate(item?.start_date);
                      const endDate = parseDate(item?.end_date);

                      if (!startDate) return "TBD";
                      if (
                        endDate &&
                        startDate.toDateString() !== endDate.toDateString()
                      ) {
                        return `${formatToUSDate(
                          item?.start_date
                        )} - ${formatToUSDate(item?.end_date)}`;
                      }
                      return formatToUSDate(item?.start_date);
                    })()}
                  </span>
                </Card.Text> */}

                {/* <Card.Text className="d-flex align-items-center mb-2 mt-3 event-timing-info">
                  <FaRegClock size={16} />
                  <span className="ps-2 ms-1">
                    {(() => {
                      if (!item?.start_date) return "TBD";

                      const start = formatDateWithoutTimezoneMMDDYYYY(
                        item.start_date
                      );
                      const end = item?.end_date
                        ? formatDateWithoutTimezoneMMDDYYYY(item.end_date)
                        : null;

                      if (end && start !== end) {
                        return `${start} - ${end}`;
                      }

                      return start;
                    })()}
                  </span>
                </Card.Text> */}
                {/* 
                <Card.Text className="d-flex align-items-center mb-2 event-timing-info">
                  <HiOutlineLocationMarker size={18} />
                  {item?.venue ? (
                    <span className="ps-2 ms-1">{item?.venue || "N/A"}</span>
                  ) : (
                    <span className="ps-2 ms-1">TBD</span>
                  )}
                </Card.Text> */}

                <Card.Text className="d-flex align-items-center mb-2 mt-3 event-timing-info">
                  <FaRegClock size={16} />
                  <span className="ps-2 ms-1">{formatEventDate(item)}</span>
                </Card.Text>
              </div>

              <Row className="mb-2">
                <Col xs={9}>
                  <Button className="w-100 btn btn-orange-lg">
                    {isPastEvent ? "View" : "RSVP"}
                  </Button>
                </Col>

                <Col xs={2} className="d-flex justify-content-center">
                  <Button
                    className="btn btn-light-lg ms-4"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowShare(true);
                    }}
                  >
                    <RxShare1 style={{ color: "#77787B" }} />
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      )}

      <ShareModal
        show={showShare}
        onHide={() => setShowShare(false)}
        link={shareLink}
        title="Share this event"
        description={item?.description}
        image={`${IMAGE_BASEURL}${item?.image_path}`}
      />
    </>
  );
};

export default EventCard;
